function isOtherOrganization(orgId: string) {
  return ['5b1122b861e0b33475048031', '55f7e08fe0683f12c9191245'].includes(orgId);
}

export {
  isOtherOrganization,
};
